import { lt, t } from "@/i18n";
import { topicsForLevel, type LevelId } from "@/math";

/**
 * Checklist of a level's topics. `selected` holds the enabled topic ids; an empty selection is
 * shown as "none" (the game itself treats an empty list as "all", so the caller should refuse to
 * save it or fall back to all).
 */
export function TopicPicker(props: {
  level: LevelId;
  selected: ReadonlySet<string>;
  onChange: (next: Set<string>) => void;
}) {
  const topics = topicsForLevel(props.level);
  const all = new Set(topics.map((td) => td.id));
  const toggle = (id: string) => {
    const next = new Set(props.selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    props.onChange(next);
  };
  return (
    <div class="topic-picker">
      <div class="topic-picker-tools">
        <span>{t("start.topics.summary", { n: props.selected.size, total: all.size })}</span>
        <button onClick={() => props.onChange(new Set(all))}>{t("start.topics.all")}</button>
        <button onClick={() => props.onChange(new Set())}>{t("start.topics.none")}</button>
      </div>
      <div class="topic-picker-list">
        {topics.map((td) => (
          <label key={td.id} class={props.selected.has(td.id) ? "on" : ""}>
            <input type="checkbox" checked={props.selected.has(td.id)} onChange={() => toggle(td.id)} />
            <span>{lt(td.name)}</span>
          </label>
        ))}
      </div>
      <p class="topic-picker-hint">{t("start.topics.hint")}</p>
    </div>
  );
}
